import React, { useContext } from "react";
import { TextField, Box } from "@mui/material";
import { recruitmentRegistrationContext } from "../../RecruitmentRegistationPage";
import { SmallHeadline, NormalText } from "../../../../components/TextParts";

export default function RequiredSkill() {
  const { requiredSkill, setRequiredSkill } = useContext(
    recruitmentRegistrationContext
  );

  return (
    <Box>
      <Box sx={{ display: "flex" }}>
        <SmallHeadline text="必須スキル" />
        <NormalText
          text="※入力必須項目です。"
          sx={{ mt: "34px", ml: "20px" }}
        />
      </Box>
      <TextField
        id="requiredSkill"
        value={requiredSkill || ""}
        multiline
        rows={3}
        sx={{ backgroundColor: "white" }}
        fullWidth
        inputProps={{ maxLength: 2048, "aria-label": "requiredSkill" }}
        onChange={(e) => setRequiredSkill(e.target.value)}
      />
    </Box>
  );
}